import React, {Component} from 'react'
import {useSelector} from 'react-redux'

import LanguageSelect from './LanguageSelect'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import logo from '../Assets/logo.svg'


//
//                    <li><LanguageSelect language={language}/></li>
const HeaderWithReturn = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)


    return (
        <header1 id="home">

            <nav id="nav-wrap">

                <a className="mobile-btn" href="/#nav-wrap" title="Show navigation">Показать навигацию</a>
                <a className="mobile-btn" href="/#home" title="Hide navigation">Скрыть навигацию</a>

                <ul id="nav" className="nav">
                    <li className="current"><Link to='/'
                                                  className="smoothscroll" activeClassName="current">{t('toMain')}</Link>
                    </li>

                </ul>

            </nav>
        </header1>
    )
}

export default HeaderWithReturn



// WEBPACK FOOTER //
// ./src/Components/HeaderWithReturn.js